import React from "react";
import { cn } from "../lib/Utils";

export function Holes({ holes, team1Id, team2Id, teamColors, match = {} }) {
    const matchDate = match.date
        ? new Date(match.date.date).toLocaleDateString("es-ES", {
            day: "2-digit",
            month: "2-digit",
            year: "2-digit",
        })
        : "";

    const matchHour = match.hour
        ? new Date(match.hour.date).toLocaleString("es-ES", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,
        })
        : "";

    return (
        <>
            <div className="hidden sm:flex w-full border-t border-gray-300 bg-white justify-between items-center py-2 px-4">
                <div className="flex space-x-1">
                    {holes.map((h, idx) => {
                        const n = idx + 1;
                        let bg = "bg-gray-100 text-gray-400";
                        if (h === team1Id) bg = `hole-winner-${teamColors[team1Id]}`;
                        if (h === team2Id) bg = `hole-winner-${teamColors[team2Id]}`;
                        return (
                            <div
                                key={n}
                                className={cn(
                                    "w-6 h-6 mr-2 sm:w-5 sm:h-5 md:w-6 md:h-6 xl:w-8 xl:h-8 text-xs xl:text-sm 2xl:w-10 2xl:h-10 2xl:text-base rounded-full flex items-center justify-center",
                                    bg
                                )}
                            >
                                {n}
                            </div>
                        );
                    })}
                </div>

                <div className="flex items-center space-x-2">
                    <span className="text-xs sm:text-xs lg:text-base font-medium text-gray-400 date-style bg-gray-100 rounded-md px-2 py-1">
                        {matchDate}
                    </span>
                    {matchHour && (
                        <span className="text-xs sm:text-xs lg:text-base font-medium text-gray-700 hour-style bg-blue-100 rounded-full px-2 py-1">
                            {matchHour}
                        </span>
                    )}
                </div>
            </div>

            <div className="sm:hidden px-4 py-2 border-t border-gray-300">
                <div className="grid grid-cols-9 gap-1">
                    {holes.map((h, idx) => {
                        const n = idx + 1;
                        let bg = "bg-gray-100 text-gray-400";
                        if (h === team1Id) bg = `hole-winner-${teamColors[team1Id]}`;
                        if (h === team2Id) bg = `hole-winner-${teamColors[team2Id]}`;
                        return (
                            <div
                                key={n}
                                className={cn(
                                    "w-6 h-6 rounded-full flex items-center justify-center text-xs",
                                    bg
                                )}
                            >
                                {n}
                            </div>
                        );
                    })}
                </div>
            </div>
        </>
    );
}
